import { Injectable } from '@angular/core';
import { SortingPipe } from 'src/app/pipes/sorting/sorting.pipe';
import { TablesPipe } from 'src/app/pipes/tables/tables.pipe';

@Injectable({
  providedIn: 'root'
})
export class PipeManager {

    constructor(
        private _tables: TablesPipe,
        private _sorting: SortingPipe
    ) { }

    tables()
    {
        return this._tables
    }

    sorting()
    {
        return this._sorting
    }

}
